/**
 * Detección de "modo embebido" en la app nativa (híbrido).
 *
 * La app móvil abre pantallas de la web dentro de una WebView ("islas web") e
 * inyecta `window.__TEMBIAPO_APP = true` ANTES de cargar el bundle (ver la app
 * Expo: app/web.tsx → injectedJavaScriptBeforeContentLoaded). Cuando está activo,
 * el cascarón oculta su propia cabecera/pie: la navegación la da el marco nativo,
 * así la isla se ve como una pantalla más de la app (sin doble topbar).
 *
 * Se evalúa una sola vez al cargar el módulo; la bandera ya está seteada porque el
 * script inyectado corre antes que cualquier JS de la página.
 */
export const IS_EMBEDDED: boolean = (() => {
  try {
    return typeof window !== 'undefined' && (window as unknown as { __TEMBIAPO_APP?: boolean }).__TEMBIAPO_APP === true;
  } catch {
    return false;
  }
})();
